import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const BannedPage = () => {
  const handleDiscordRedirect = () => {
    window.open('https://discord.com', '_blank');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-md w-full mx-4">
        <div className="bg-card border border-border rounded-xl p-8 text-center shadow-lg">
          <div className="mb-6">
            <AlertTriangle className="h-16 w-16 mx-auto text-destructive mb-4" />
            <h1 className="text-2xl font-bold text-foreground mb-2">
              Account Banned
            </h1>
            <p className="text-muted-foreground">
              Your account has been banned. If you feel this is a mistake please reach out to our team over discord.
            </p>
          </div>
          
          <Button 
            onClick={handleDiscordRedirect}
            className="w-full"
            variant="outline"
          >
            Contact Support on Discord
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BannedPage;